<main id="main">
    <!-- ======= Breadcrumbs ======= -->
    <div class="breadcrumbs" data-aos="fade-in">
        <div class="container">
            <h2>Videos</h2>
        </div>
    </div><!-- End Breadcrumbs -->
    <!-- ======= Services Section ======= -->
    <section id="services" class="services">
        <div class="container" data-aos="fade-up">

            <!-- <div class="section-title">
                <h2>Services</h2>
                <p>Videos</p>
            </div> -->

            <div class="row">
                <div class="col-lg-4 col-md-6 align-items-stretch" *ngFor="let video of videoList | async" data-aos="zoom-in" data-aos-delay="100">
                    <div class="icon-boxx">
                    <iframe width="100%" height="100%" [src]="video.body"
                        title="YouTube video player" frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        allowfullscreen></iframe>
                        <p><b>{{video.title}}</b></p>
                    </div>
                </div>
            </div>
        </div>
    </section><!-- End Services Section -->
</main>